import React from "react";
import { Button } from "react-materialize";

export default function VireProfileBtnChange({ data }) {
  return (
    <Button
      className=""
      id="btn-change"
      node="button"
      waves="light"
      onClick={() =>
        (window.location.href = `/employees/profile/?tab=employeeinfo&id=${data.idu}`)
      }
      style={{
        borderRadius: "8px",
      }}
    >
      Change
    </Button>
  );
}
